import { isEmpty } from './../../shared/core/util';
import { isNullOrUndefined } from 'util';
import { Component, OnInit, Input, ChangeDetectorRef, AfterContentChecked } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { Credentials } from '../../shared';

@Component({
    selector: 'jhi-credentials',
    templateUrl: './credentials.component.html',
    styleUrls: ['./credentials.component.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class CredentialsComponent implements OnInit, AfterContentChecked {
    confirmPassword: string;

    @Input()
    confirmEmail: any;

    @Input()
    credentials: Credentials;

    @Input()
    isRepresentant: boolean;

    @Input()
    isNewAccount = true;

    @Input()
    isCreateAccountBtnClicked: boolean;

    @Input()
    emailRollBack: boolean;

    isFCUser = false;

    isPasswordRequired: boolean;

    showsPWFields = false;

    specialCharacters = '~ \" # \' { ( [ - | è ` _ ç ^ à @ ) ] ° = } + ^ ¨ $ £ ¤ % ù * µ ! § / : ; . , ? < >';

    constructor(private form: NgForm, private cd: ChangeDetectorRef) {
    }

    ngOnInit() {
        this.confirmEmail = this.confirmEmail || {};
        this.confirmEmail.confirmEmail = this.confirmEmail.confirmEmail || this.credentials.email;
        this.isFCUser = !isNullOrUndefined(this.credentials.franceConnectSubscription);
        this.isPasswordRequired = this.isNewAccount;
    }

    ngAfterContentChecked(): void {
        this.cd.detectChanges();
    }

    updateValueAndValidity(controlNames: string[]) {
        (controlNames || [])
            .map(controlName => this.form.controls[controlName])
            .filter(control => control && control.touched)
            .forEach(control => control.updateValueAndValidity());
    }

    checkRequiredPasswords(_event): void {
        this.isPasswordRequired =
            this.isNewAccount || !isEmpty(this.credentials.oldPassword || this.credentials.password || this.confirmPassword);
        if (!this.isPasswordRequired) {
            this.credentials.password = null;
            this.credentials.oldPassword = null;
        }
        this.cd.detectChanges();
    }

    showPWFields(): void {
        this.showsPWFields = !this.showsPWFields;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/account/credentials/credentials.component.ts